<div id="guidelines">
  <div class="filters" id="filter-header">
    @if (translations$ | async; as translations) {
    <div>
      <ca-multi-select-dropdown [label]="translations.categoryFilterLabel" [options]="categoryOptions" [selected]="selectedCategoryFilters"
        (selectionChange)="setMultiSelectFilter('categories', $event)" labelProperty="label"></ca-multi-select-dropdown>
      <ca-multi-select-dropdown [label]="translations.presetFilterLabel" [options]="presetOptions" [selected]="selectedPresetFilters"
        (selectionChange)="setMultiSelectFilter('presets', $event)" labelProperty="label"></ca-multi-select-dropdown>
      <button class="reset-filters" (click)="resetFilters()"><span
          class="material-symbols-outlined">filter_alt_off</span>{{translations.clearButtonText}}</button>
    </div>
    <div>
      <button class="cta-btn" (click)="exportGuidelines()" [disabled]="selectedRows.size === 0">
        <span class="material-symbols-outlined">
          download
        </span>{{ translations.downloadButtonText }}
      </button>

    </div>
    }
  </div>
  <div id="chart-container">
    <aside>
      <div class="global-toggle">
        <div class="chart-intro">
          <h2 class="chart-title-small">{{(translations$ |async)?.chart1Title}}</h2>

          <p>{{(translations$ |async)?.chart1Intro}}</p>


        </div>
        <ul #strategySummary class="strategy-summary">
          @for (strategy of (filteredStrategies$ | async); track strategy.id) {
          <li>{{ strategy.title }}: {{ getSelectedSummary(strategy) }}</li>
          }
        </ul>
        <div class="left-panel">
          <p class="selectionpercentage">{{ selectionPercentage | number:'1.0-1' }}%</p>

        </div>

        <apx-chart #apexChart [series]="polarChartOptions.series" [chart]="polarChartOptions.chart"
          [fill]="polarChartOptions.fill" [stroke]="polarChartOptions.stroke" [yaxis]="polarChartOptions.yaxis"
          [legend]="polarChartOptions.legend" [dataLabels]="polarChartOptions.dataLabels"
          [responsive]="polarChartOptions.responsive" [colors]="polarChartOptions.colors"
          [plotOptions]="polarChartOptions.plotOptions" [xaxis]="polarChartOptions.xaxis"
          [tooltip]="polarChartOptions.tooltip" [ngStyle]="{
            zoom: isZoomed ? '150%' : '100%',

          }">
        </apx-chart>
      </div>
    </aside>
    <div id="bar-chart">
      <h2 class="chart-title-small">{{(translations$ |async)?.chart2Title}}</h2>
      <p>{{(translations$ |async)?.chart2Intro}}</p>
      <apx-chart [series]="barChartOptions.series" [chart]="barChartOptions.chart" [fill]="barChartOptions.fill"
        [stroke]="barChartOptions.stroke" [colors]="barChartOptions.colors" [dataLabels]="barChartOptions.dataLabels"
        [legend]="barChartOptions.legend" [tooltip]="barChartOptions.tooltip" [labels]="barChartOptions.labels"
        [responsive]="barChartOptions.responsive" [plotOptions]="barChartOptions.plotOptions"></apx-chart>
    </div>
  </div>
  @if (translations$ | async; as translations){
  <div id="strategies">


    <div id="strategies">
      @for(strategy of (filteredStrategies$ | async); track strategy.id ){
      <div class="strategy-group" [class.open]="strategy.id === openAccordeon" id="{{ strategy.id }}">
        <a class="strategy-header" (click)="toggleStrategy($event.target, strategy)">
          @if(strategy.image && strategy.image.src) {
          <img [src]="base + strategy.image.src" [alt]="strategy.image.alt" />
          } @else {
          <img />
          }
          <h2>{{ strategy.title }}</h2>
          <div [outerHTML]="strategy.description"></div>
          <span class="material-symbols-outlined arrow-right">
            arrow_right_alt
          </span>
        </a>

        <div class="guidelines-table mobilescroll">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>{{translations.columns.title}}</th>
                <th>{{translations.columns.description}}</th>
                <th>{{translations.columns.presets}}</th>
                <th>{{translations.columns.category}}</th>
                <th>{{translations.columns.action}}</th>
              </tr>
            </thead>
            <tbody>
              @for(guideline of strategy.guidelines; track guideline.id ){
              <tr [attr.id]="guideline.id">
                <td>
                  <input type="checkbox" [checked]="isGuidelineSelected(guideline)"
                    (change)="toggleGuideline(guideline, $event)" />
                </td>
                <td>{{ guideline.title }}</td>
                <td>
                  <div [outerHTML]="guideline.description"></div>
                </td>
                <td>
                  <div class="badges">
                    @for (preset of guideline.presets; track preset) {
                    <span class="badge preset"> {{guideline.presetMap[preset]}} </span>
                    }
                  </div>
                </td>
                <td>
                  <div class="badges">
                    @for (cat of guideline.categories; track cat) {
                    <span class="badge category"> {{guideline.categoriesMap[cat]}} </span>
                    }
                  </div>
                </td>
                <td>
                  <a class="material-symbols-outlined read-more" (click)="onReadMoreClick(strategy, guideline)"
                    [routerLink]="guideline.routerLink | languagePrefix | async"> read_more </a>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      }
    </div>
  </div>
  }
</div>
